import { FileInput, Image, Stack, Text } from '@mantine/core';
import { IconPhoto } from '@tabler/icons-react';

const ImageInput = ({ file, setFile, imageUrl, description }) => {
  const finalImageUrl = file ? URL.createObjectURL(file) : imageUrl;

  return (
    <Stack gap="xs">
      {finalImageUrl && <Image src={finalImageUrl} alt="Uploaded" style={{ width: 'auto', height: 'auto', maxHeight: 150 }} fit="contain" />}

      {description && <Text size="sm" c="dimmed">{description}</Text>}

      <FileInput
        mt="xs"
        accept=".jpg,.png"
        placeholder="Choose image file"
        leftSection={<IconPhoto size={16} />}
        onChange={setFile}
      />
      <Text size="xs" c="dimmed">We accept only "png" and "jpg" image files</Text>
    </Stack>
  );
};

export default ImageInput;
